import { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { getOrders } from '../api'
import { useTelegram } from '../context/TelegramContext'
import Header from '../components/Header'
import './Orders.css'

const Orders = () => {
  const navigate = useNavigate()
  const [orders, setOrders] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)
  const { showBackButton, hideBackButton, user } = useTelegram()

  useEffect(() => {
    loadOrders()
    showBackButton(() => navigate('/'))
    return () => hideBackButton()
  }, [])

  const loadOrders = async () => {
    try {
      setLoading(true)
      const data = await getOrders(user?.id || 0)
      setOrders(data)
      setError(null)
    } catch (err) {
      console.error('Ошибка загрузки заказов:', err)
      setError('Не удалось загрузить заказы')
    } finally {
      setLoading(false)
    }
  }

  const getStatusText = (status) => {
    const statuses = {
      'new': 'Новый',
      'confirmed': 'Подтвержден',
      'paid': 'Оплачен',
      'shipped': 'Отправлен',
      'completed': 'Завершен',
      'cancelled': 'Отменен',
      'awaiting_payment': 'Ожидает оплаты'
    }
    return statuses[status] || status
  }

  const getStatusClass = (status) => {
    if (['completed', 'paid'].includes(status)) return 'success'
    if (['cancelled'].includes(status)) return 'error'
    if (['awaiting_payment'].includes(status)) return 'warning'
    return 'default'
  }

  if (loading) {
    return (
      <div className="orders-loading">
        <div className="spinner"></div>
        <p>Загрузка заказов...</p>
      </div>
    )
  }

  if (error) {
    return (
      <div className="orders-error">
        <div className="error-icon">❌</div>
        <h3>Ошибка</h3>
        <p>{error}</p>
        <button className="btn btn-primary" onClick={loadOrders}>
          Попробовать снова
        </button>
      </div>
    )
  }

  if (orders.length === 0) {
    return (
      <div className="orders">
        <Header title="Мои заказы" showBack={true} />
        <div className="orders-empty">
          <div className="empty-icon">📦</div>
          <h2>Заказов пока нет</h2>
          <p>Оформите первый заказ в каталоге</p>
          <button className="btn btn-primary" onClick={() => navigate('/')}>
            Перейти в каталог
          </button>
        </div>
      </div>
    )
  }

  return (
    <div className="orders">
      <Header title="Мои заказы" showBack={true} />

      <div className="orders-list">
        {orders.map(order => (
          <div key={order.id} className="order-card fade-in">
            <div className="order-header">
              <div className="order-number">Заказ #{order.id}</div>
              <div className={`order-status ${getStatusClass(order.status)}`}>
                {getStatusText(order.status)}
              </div>
            </div>

            <div className="order-info">
              <div className="info-row">
                <span className="info-label">Дата:</span>
                <span className="info-value">
                  {new Date(order.created_at).toLocaleDateString('ru-RU')}
                </span>
              </div>
              
              <div className="info-row">
                <span className="info-label">Сумма:</span>
                <span className="info-value">{order.total_amount} ₽</span>
              </div>

              {order.delivery_method && (
                <div className="info-row">
                  <span className="info-label">Доставка:</span>
                  <span className="info-value">{order.delivery_method}</span>
                </div>
              )}
            </div>

            {order.delivery_address && (
              <div className="order-address">
                📍 {order.delivery_address}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  )
}

export default Orders


